module.exports = __webpack_public_path__ + "static/media/fly0254.fa1d9200.webp";